<template>
  <Card header="You have new report preferences" :successIcon="true">
    <div class="vertical-align">
      <p>{{ text[0] }}</p>
      <p>{{ text[1] }}</p>
      <p>{{ text[2] }}</p>
      <p>{{ text[3] }}</p>
    </div>

    <button class="btn btn-outline-primary" @click="onClick()">
      Edit report preferences
    </button>
    <p>or</p>
    <p class="link link-cancel" @click="onClickLink()">
      Cancel recurring report
    </p>
  </Card>
</template>

<script>
import Card from './index';
import GenerateReport from '../GenerateReport';
import { mapGetters } from 'vuex';
import { getPartialScheduleText } from '../helper.js';
import dayjs from 'dayjs';

export default {
  components: { Card, GenerateReport },
  props: ['data'],
  methods: {
    onClick() {
      this.$emit('onEdit', true);
    },
    onClickLink() {
      this.$emit('onDelete', true);
    },
    calculateStartingDate() {
      if (this.data.frequency === 'Daily') {
        return dayjs().add(this.data.cron.day, 'day');
      } else if (this.data.frequency === 'Weekly') {
        const today = dayjs().day(); // [0-6]
        const expectDay = this.data.cron.week;
        if (expectDay > today) {
          return dayjs().add(expectDay - today, 'day');
        } else {
          return dayjs().add(expectDay - today + 7, 'day');
        }
      } else {
        // logic based on cron expression
        const startMonth = 1;
        const monthInterval = this.data.cron.month;
        for (let i = 0; i <= 12; i++) {
          if (i % monthInterval !== 0) continue;
          // dayjs month start from 0
          if (startMonth + i >= dayjs().month() + 1) {
            const today = dayjs().date();
            const expectDay = this.data.cron.day;
            if (expectDay > today) {
              return dayjs().set('date', expectDay);
            } else {
              const nextMonth = startMonth + i;
              return dayjs()
                .set('month', nextMonth)
                .set('date', expectDay);
            }
          }
        }
      }
    }
  },
  computed: {
    ...mapGetters('authStore', ['oidcUser']),
    ...mapGetters('dataStore', ['selectedASN']),
    text() {
      if (!this.data) return ['', '', ''];
      let lineOne = 'You will receive your report ';
      let lineTwo = this.oidcUser.email;
      const lineThree = `For: origin AS ${this.selectedASN.id}`;

      const lineFour = `Start Date: ${this.calculateStartingDate().format(
        'DD/MM/YY'
      )}`;
      lineOne += getPartialScheduleText(this.data);
      lineOne += ' to:';
      return [lineOne, lineTwo, lineThree, lineFour];
    }
  }
};
</script>

<style lang="scss" scoped>
button.btn.btn-outline-primary {
  padding: 0 8px;
}
.link {
  color: #007bbd;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
}
.link-cancel {
  color: #b00020;
}
.vertical-align {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  text-align: center;
}
</style>
